import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord } from './Model';

export interface IVaccineVirusTypeModel extends IModel {
  vaccineVirusTypeId: number;
  name: string;
}

export class VaccineVirusTypeModel
  extends Model
  implements ModelRecord<IVaccineVirusTypeModel>
{
  vaccineVirusTypeId: number;
  name: string;

  constructor(params?: Partial<IVaccineVirusTypeModel>) {
    super(params);

    this.vaccineVirusTypeId = defaultTo(params?.vaccineVirusTypeId, 0);
    this.name = defaultTo(params?.name, '');
  }
}
